import Card from '@mui/material/Card'
import type { ElementType, ReactElement } from 'react'
import { cloneElement } from 'react'
import { RaGrid } from './RaGrid'

/**
 * Two side-by-side panels for a Show view.
 *
 * Vendored from ra-compact-ui@3.3.0 rather than imported: upstream declares a
 * `@mui/material: ^5.x` peer and lays out with `<Grid item md={4}>`, which MUI
 * 9 no longer understands — the columns silently collapse to full width.
 * <RaGrid> translates the same props to MUI 9's `size` API.
 */
const defaultLeftSideProps: SideProps = { lg: 4, md: 6, xl: 4, xs: 12, component: Card }
const defaultRightSideProps: SideProps = { lg: 8, md: 6, xl: 8, xs: 12, component: Card }

export interface SideProps {
  component?: ElementType
  lg?: number
  md?: number
  xl?: number
  xs?: number
  [key: string]: unknown
}

export interface ShowSplitterProps {
  leftSide?: ReactElement
  leftSideProps?: SideProps
  rightSide?: ReactElement
  rightSideProps?: SideProps
}

export const ShowSplitter = ({
  leftSide,
  leftSideProps = defaultLeftSideProps,
  rightSide,
  rightSideProps = defaultRightSideProps,
  ...props
}: ShowSplitterProps) => {
  const { component: LeftContainer = Card, ...restLeftProps } = leftSideProps
  const { component: RightContainer = Card, ...restRightProps } = rightSideProps

  return (
    <RaGrid container spacing={4}>
      {leftSide && (
        <RaGrid item {...restLeftProps}>
          <LeftContainer>{cloneElement(leftSide, props)}</LeftContainer>
        </RaGrid>
      )}
      {rightSide && (
        <RaGrid item {...restRightProps}>
          <RightContainer>{cloneElement(rightSide, props)}</RightContainer>
        </RaGrid>
      )}
    </RaGrid>
  )
}

export default ShowSplitter
